import { url } from "../../config";
import PropTypes from "prop-types";

const Playlist = ({ playlist, index }) => {
  if (playlist.type === "media--video") {
    return (
      <div className={`fullscreen-bg video`} key={playlist.field_media_video_file.id}>
        <video id={`theVideo${index}`} width="320" height="180" muted="muted" playsInline="playsinline" preload="auto">
          <source
            src={`${url}${playlist.field_media_video_file.uri.url}`}
            type={playlist.field_media_video_file.filemime}
          />
        </video>
      </div>
    );
  }

  if (playlist.type === "media--image") {
    return (
      <div className={`fullscreen-bg`} key={playlist.field_media_image.id}>
        <img src={`${url}${playlist.field_media_image.uri.url}`} alt="" />
      </div>
    );
  }

  return <>Cannot read field.</>;
};

Playlist.propTypes = {
  playlist: PropTypes.object.isRequired,
};

export default Playlist;
